import { AppointmentComplianceDto } from '@peartherapeutics/hylia-api-client';
import moment, { Moment } from 'moment';
import { isVisited } from '../LastClinicVisit/VisitModal/utils';

export const CLINIC_VISIT_DIALOG_TRACKING_ACTIONS: { [key: string]: string } = {
  SHOWN: 'Shown',
  DISMISSED: 'Dismissed',
  SUBMITTED: 'Submitted',
};

const WANRNING_TYPES: { [key: string]: string } = {
  NONE: 'none',
  UPCOMING: 'upcoming',
  REENABLE: 're-enable',
};

export const getWarningType = (
  lastClinicVisitDate?: Nullable<Moment>,
): string => {
  if (!lastClinicVisitDate) return WANRNING_TYPES.NONE;

  const diffDays = moment().diff(lastClinicVisitDate, 'days');
  if (diffDays < 20) return WANRNING_TYPES.NONE;
  if (diffDays >= 20 && diffDays < 31) return WANRNING_TYPES.UPCOMING;
  return WANRNING_TYPES.REENABLE;
};

export const preselectDay = (
  patientAppointmentCompliances: AppointmentComplianceDto[],
  currentWithTimezone: Date,
) => {
  return isVisited(patientAppointmentCompliances, currentWithTimezone)
    ? undefined
    : currentWithTimezone;
};
